import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Form, TextInput, FormField, Button, Text } from "grommet";
import AuthService from "../../services/auth.service";
import { presentToastErrorContent, presentToastSuccess } from "@shared/Toast";
import { useTranslation } from "react-i18next";

// import PropTypes from 'prop-types';

export default function ChangePwdComponent(props) {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const { token } = useParams();
  const [errorMessage, setErrorMessage] = useState("");
  const onPasswordChange = (event) => setPassword(event.target.value);
  const onPassword2Change = (event) => setPassword2(event.target.value);

  const handleLogin = (e) => {
    if (password2 !== password) {
      setErrorMessage(t("changePassword.passwordMismatch"));
      return;
    }

    AuthService.change(token, password).then(
      () => {
        presentToastSuccess(t("changePassword.success"));
        window.location.href = "/sign-in";
      },
      (error) => {
        presentToastErrorContent(error);
      }
    );
  };

  return (
    <Form {...props} onSubmit={handleLogin}>
      <Box gap="medium">
        <FormField label={t("changePassword.password")} htmlFor="password">
          <TextInput
            id="password"
            placeholder={t("changePassword.passwordPlaceholder")}
            type="password"
            onChange={onPasswordChange}
          />
        </FormField>

        <FormField label={t("changePassword.confirmPassword")} htmlFor="password2">
          <TextInput
            id="password2"
            placeholder={t("changePassword.confirmPasswordPlaceholder")}
            type="password"
            onChange={onPassword2Change}
          />
        </FormField>
        {errorMessage && (
          <Box pad={{ horizontal: "small" }}>
            <Text color="status-error">{errorMessage}</Text>
          </Box>
        )}
        <Button
          label={t("changePassword.submit")}
          primary
          type="submit"
          alignSelf="center"
          disabled={password === ""}
        />
      </Box>
    </Form>
  );
}

ChangePwdComponent.propTypes = {};
ChangePwdComponent.defaultProps = {};
